module.exports = {"id":"dp5_1l1q1","text":"Identifying technical problems","instructions":"Technical problems are a normal part of using digital devices.","multiselect":false,"category":"5.1","questionType":"PickOne","random":false,"options":[{"id":"dp5_1l1q1-a1","text":"True","score":1.8},{"id":"dp5_1l1q1-a2","text":"Not sure","score":0},{"id":"dp5_1l1q1-a3","text":"False","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l1q1.json
// module id = 1281
// module chunks = 41